/*
 * Copyright (c) 2023 Your Company Name
 * All rights reserved.
 */
/*
 *   Copyright (c) 2023
 *   All rights reserved.
 */
import axios from "axios";
import {
  listePaiementAllCustumerURL,
  listPaiementOFOneCustomerURL,
  itemPaiementURL,
  delPaiementURL,
} from "config/api";
import { addPaiementURL, updatePaiementURL } from "config/api";

import { encryptStorage } from "components/EncryptedStorage/encryptedStorage";
import {
  verifPurchaseURL,
  enregistrerRappelPaiementURL,
  listLastRappelPaiementURL,
  listCategoryPaiementURL,
} from "config/api";

export const listRelanceClientInfoForUser = async (data) => {
  const token =
    "Bearer " + (await encryptStorage.getItem("userInfo").userToken);
  //console.log('get url = ', listePaiementAllCustumerURL)
  //console.log(' saveRelanceClientInfo = ', data)
  return axios
    .post(listLastRappelPaiementURL, data, {
      headers: {
        Authorization: token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
    .then((res) => res.data);
};

export const listCategoryPaiement = async () => {
  const token =
    "Bearer " + (await encryptStorage.getItem("userInfo").userToken);
  //console.log('get url = ', listePaiementAllCustumerURL)
  //console.log(' saveRelanceClientInfo = ', data)
  return axios
    .post(
      listCategoryPaiementURL,
      {},
      {
        headers: {
          Authorization: token,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    )
    .then((res) => res.data);
};

export const saveRelanceClientInfo = async (data) => {
  const token =
    "Bearer " + (await encryptStorage.getItem("userInfo").userToken);
  //console.log('get url = ', listePaiementAllCustumerURL)
  //console.log(' saveRelanceClientInfo = ', data)
  return axios
    .post(enregistrerRappelPaiementURL, data, {
      headers: {
        Authorization: token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
    .then((res) => res.data);
};

export const getListePaiementAllCustumer = async (data) => {
  const token =
    "Bearer " + (await encryptStorage.getItem("userInfo").userToken);
  //console.log("get url = ", listePaiementAllCustumerURL);
  //console.log('get getListePaiementAllCustumer = ', data.client)
  return axios
    .post(listePaiementAllCustumerURL, data.client, {
      headers: {
        Authorization: token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
    .then((res) => res.data);
};

export const getListePaiementOFOneCustomer = async (data) => {
  const token =
    "Bearer " + (await encryptStorage.getItem("userInfo").userToken);
  // console.log('get getListePaiementAllCustumer = ', data)
  return axios
    .post(listPaiementOFOneCustomerURL, data.client, {
      headers: {
        Authorization: token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
    .then((res) => res.data);
};

export const getItemPaiement = async (data) => {
  const token =
    "Bearer " + (await encryptStorage.getItem("userInfo").userToken);
  // console.log('get ITEM paiement = ', data)
  return axios
    .get(itemPaiementURL + "/" + data.paiementId, {
      headers: {
        Authorization: token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
    .then((res) => res.data);
};

export const addPaiementService = async (data) => {
  const token =
    "Bearer " + (await encryptStorage.getItem("userInfo").userToken);

  const dataToSend = {
    ...data.paiement,
  };
  // console.log('url =' + addPaiementURL + '    addPaiementService', dataToSend)
  return axios
    .post(addPaiementURL, dataToSend, {
      headers: {
        Authorization: token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
    .then((res) => res.data);
};

export const updatePaiementService = async (data) => {
  const token =
    "Bearer " + (await encryptStorage.getItem("userInfo").userToken);
  // console.log('url =' + updatePaiementURL + '    updatePaiementService', data)
  return axios
    .put(updatePaiementURL, data.paiement, {
      headers: {
        Authorization: token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
    .then((res) => res.data);
};

export const deletePaiementService = async (data) => {
  const token =
    "Bearer " + (await encryptStorage.getItem("userInfo").userToken);

  return axios
    .post(delPaiementURL, data.paiement, {
      headers: {
        Authorization: token,
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
    .then((res) => res.data);
};

export const verifPurchaseService = (username, token) => {
  const data = JSON.stringify({
    user: username,
  });

  const tokenAx = "Bearer " + token;

  return axios.post(verifPurchaseURL, data, {
    headers: {
      Authorization: tokenAx,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};
